import React, { useState, useEffect } from 'react';

export default function PrivacyModal() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasAcceptedPrivacy = localStorage.getItem('privacyAccepted');
    if (!hasAcceptedPrivacy) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('privacyAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-20">
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="relative bg-[#333333] p-6 rounded-lg shadow-lg max-w-md w-full text-white">
        <h2 className="font-bold text-lg mb-4">Privacy Statement</h2>
        <p className="mb-6">This application does not require the collection of any personal information. However, despite this, students could accidentally enter personal information into the tool while using it.</p>
        <p className="mb-6">Students are encouraged to contact their instructor and/or their program area for information and guidance on how to safely use this tool and reduce the risk of inadvertent disclosure of personal information. </p>
        <p className='mb-6'>Students may also contact privacy@jibc.ca if they have any questions or concerns about the use of this tool.</p>
        <div className="flex justify-end">
          <button onClick={handleAccept} className="bg-[#1e1e1e] text-white border border-white rounded-lg px-6 py-2 hover:bg-[#444] focus:outline-none focus:border-[#555]">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
